<template>
  <div :class="{ card: !small, 'card-small': small, 'disabled-card': disabled }">
    <div
      v-if="title"
      class="flex items-center"
      :class="{
        'mb-2 md:mb-5': (open || !togglable) && $slots.default,
        'cursor-pointer': togglable,
      }"
      @click="toggle"
    >
      <div
        v-if="icon"
        class="shrink-0 flex items-center justify-center sm:h-10 sm:w-10 rounded-full mx-0 h-8 w-8"
        :class="bgColorClass || `bg-${color}-100`"
      >
        <component
          :is="icon"
          class="h-4 w-4 sm:h-6 sm:w-6"
          :class="textColorClass || `text-${color}-600`"
        />
      </div>
      <h3
        class="font-medium"
        :class="{
          [`text-${titleSize}`]: true,
          'ml-2': !!icon,
        }"
      >
        {{ title }}
      </h3>
      <div v-if="togglable" class="ml-auto">
        <component :is="toggleIcon" :key="toggleIcon" class="h-6 w-6 text-gray-500" />
      </div>
      <slot name="header-right" />
    </div>
    <slot v-if="open || !togglable" />
  </div>
</template>

<script>
import { computed, ref } from 'vue'
const colors = {
  error: 'red',
  warning: 'yellow',
  info: 'blue',
  success: 'green',
}
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => {
        return ['info', 'warning', 'error', 'success'].includes(value)
      },
    },
    titleSize: {
      type: String,
      default: 'base',
    },
    togglable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bgColorClass: {
      type: String,
      default: '',
    },
    textColorClass: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
    // initial state when card is togglable
    initial: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['opened'],
  setup(props, context) {
    const color = computed(() => colors[props.type])
    const open = ref(props.initial)
    const toggleIcon = computed(() => (open.value ? 'ChevronUpIcon' : 'ChevronDownIcon'))
    const toggle = () => {
      open.value = !open.value
      if (open.value) {
        context.emit('opened')
      }
    }
    return {
      color,
      open,
      toggleIcon,
      toggle,
    }
  },
}
</script>
